import { t } from 'ttag';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';
import {
  AudioDefinition,
  GAUGE,
  LayoutHalfPageDefinition,
  LAYOUT_HALF_PAGE
} from '../items';
import { Translator } from '../Translator';
import { TextHelper } from './itemHelpers/TextHelper';
import { translate } from './translate';

const getColorByIndex = (index: number) => {
  switch (index) {
    case 0:
      return '#F53258';
    case 1:
      return '#F78837';
    case 2:
      return '#F9BF60';
    case 3:
      return '#DBF337';
    case 4:
      return '#46E275';
    default:
      return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
};

const getSteps = (
  items?: Array<{
    id: string;
    value: string;
    subvalue?: string;
    feedback: string;
    feedbackAudios: Array<AudioDefinition>;
  }>
) => {
  const steps: Array<{
    id: string;
    color: string;
    value: string | number;
    label: string;
    feedback?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    feedbackAudios?: any;
  }> = [];

  (items || []).forEach((item, index, arr) => {
    const label =
      steps.length == 0 ? '😡' : steps.length == arr.length - 1 ? '😀' : '';
    steps.push({
      id: item.id,
      color: getColorByIndex(index),
      value: item?.value || '',
      label: item?.subvalue && item?.subvalue != '' ? item?.subvalue : label,
      feedback: item?.feedback,
      feedbackAudios: item?.feedbackAudios
    });
  });

  return steps;
};

export const Interactive12: Translator = sequence => {
  const CardElement = sequence.items?.find(
    item => item.__typename == 'Card'
  ) as ItemOfType<'Card'>;

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question': {
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...TextHelper(item as any),
            {
              type: GAUGE,
              id: '1',
              values: {
                steps: item.items ? getSteps(item.items as []) : [],
                from: CardElement
                  ? (CardElement?.title as string)
                  : t`Ineffective`,
                to: CardElement
                  ? (CardElement.subtitle as string)
                  : t`Highly effective`,
                shape: 'round'
              },
              items: []
            }
          ]
        } as LayoutHalfPageDefinition;
      }
      default:
        return null;
    }
  });
};
